import React, { useState, useEffect } from 'react';
import {  FaEdit } from "react-icons/fa";
import { IoInformationCircleOutline } from "react-icons/io5";
import { useDispatch, useSelector } from 'react-redux';
import { questionListRes, questionListTodo } from '../../LMS_Redux/LMS_Slices/Quiz/QuestionList';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import PropagateLoader from "react-spinners/PropagateLoader";
import { Tooltip } from 'react-tooltip';
import { useNavigate } from 'react-router-dom';
import { questionDetailsRes, questionDetailsTodo } from '../../LMS_Redux/LMS_Slices/Quiz/QuestionDetails';
import { FaCircleCheck, FaTrash } from 'react-icons/fa6';
import { PiSealCheckBold } from 'react-icons/pi'
import { deleteQuestionRes, deleteQuestionTodo } from '../../LMS_Redux/LMS_Slices/Quiz/DeleteQuestion';
import Swal from 'sweetalert2';

export default function QuestionList() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.questionList && state.questionList.data && state.questionList.data.data)
    const que_detail = useSelector(state => state.questionDetails && state.questionDetails.data && state.questionDetails.data.data && state.questionDetails.data.data[0])
    const [loading, setLoading] = useState(false)
    const [detailModal, setDetailModal] = useState(false)
    const [modalLoading, setModalLoading] = useState(true)
    const [bool, setBool] = useState(false)
    // console.log(que_detail)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'SERIAL',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 100
        },
        {
            headerName: 'QUESTIONS',
            field: 'question',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: `QUESTION ID`,
            field: 'id',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'REMARK',
            field: 'remark',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        // {
        //     headerName: 'DEPARTMENT',
        //     field: 'department_data',
        //     valueFormatter: function (params) {
        //         return params.data && params.data.department_data && params.data.department_data.map(val => `${val.label}`).join(',')
        //     },
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: true,
        //     // wrapText: true,
        //     // autoHeight: true,
        // },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => <span className={params.value == 'active' ? 'badge text-bg-success' : 'badge text-bg-danger'} style={{ textTransform: 'capitalize' }}>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <IoInformationCircleOutline  size={20} className='eye'
                        onClick={() => question_details(params)}
                        data-tooltip-id='details'
                        data-tooltip-content="Question Details!"
                        data-tooltip-place="bottom"
                    />
                    {params.data.isEditable ?
                        <FaEdit size={20} className='edit ms-3'
                            onClick={() => edit_question(params)}
                            data-tooltip-id='edit'
                            data-tooltip-content="Edit Question!"
                            data-tooltip-place="bottom"
                        />
                        : ''
                    }
                    <FaTrash size={18} className='delete ms-3'
                        onClick={() => delete_question(params)}
                        data-tooltip-id='delete'
                        data-tooltip-content="Delete Question!"
                        data-tooltip-place="bottom"
                    />

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='edit' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='delete' style={{ backgroundColor: "rgb(239, 61, 80)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
        }
    ]);

    const question_details = (params) => {
        setModalLoading(true)
        dispatch(questionDetailsTodo(params.data.id)).then(() => question_details_res())
        setDetailModal(true)
    }

    const question_details_res = () => {
        if (questionDetailsRes && questionDetailsRes.success) {
            setModalLoading(false)
        } else {
            setModalLoading(false)
        }
    }

    const edit_question = (params) => {
        navigate('/add_question', { state: params.data })
    }

    const delete_question = (params) => {
        Swal.fire({
            title: 'Delete Question',
            text: `Are you sure want to Delete Question?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#105684',
            cancelButtonColor: '#9d9d9d',
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result.isConfirmed) {
                // console.log(val)
                dispatch(deleteQuestionTodo(params.data.id)).then(() => delete_que_res())
            }
        })
    }

    const delete_que_res = () => {
        if (deleteQuestionRes && deleteQuestionRes.success) {
            setBool(!bool)
            Swal.fire(
                'Question Status',
                deleteQuestionRes.message,
                'success'
            )
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: deleteQuestionRes.message,
            })
        }
    }

    const question_res = () => {
        if (questionListRes && questionListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(questionListTodo({ "department": [], "status": '', "temp": 'list' })).then(() => question_res())
    }, [bool])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Quiz Management / </span>
                    <span className='icon2'>Question List</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <DataTables
                        rowData={data}
                        columnDefs={columnDefs}
                    />
                }
            </div>

            <div className={detailModal ? 'modal fade show d-block' : 'modal fade show d-none'} style={{ background: 'rgba(0,0,0,0.8)' }}>
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">

                            <h5 className="modal-title">Question Details</h5>
                            <span className={que_detail && que_detail.status == 'active' ? 'badge text-bg-success ms-1' : 'badge text-bg-danger ms-1'} style={{ textTransform: 'capitalize' }}>{que_detail && que_detail.status}</span>

                            <button type="button" className="btn-close" style={{ boxShadow: 'none' }} onClick={() => setDetailModal(false)}></button>
                        </div>

                        {modalLoading ?
                            <div className="modal-body">
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </div>
                            :
                            <div className="modal-body">
                                {/* <div className='d-flex align-items-baseline'>
                                    <span style={{ color: '#9d9d9d' }}>Group Name:</span>
                                    <h6 className='ms-2'>{details && details.group_name}</h6>
                                </div>
                                <div className='d-flex align-items-baseline mb-2'>
                                    <span style={{ color: '#9d9d9d' }}>Created on:</span>
                                    <h6 className='ms-2'>{new Date(details && details.createdAt).toDateString()}</h6>
                                </div> */}

                                <div>

                                    <div className='d-flex align-items-center justify-content-between'>

                                        <div className='mb-2'>
                                            {/* <span style={{ color: '#9d9d9d', fontWeight: '500' }}>Type:</span> */}
                                            <h5 className=''>{que_detail && que_detail.remark}</h5>
                                        </div>

                                        {/* <div className='mb-2'>
                                            <span style={{ color: '#9d9d9d', fontWeight: '500' }}>Status:</span>
                                            <span className={que_detail && que_detail.status == 'active' ? 'badge text-bg-success ms-1' : 'badge text-bg-danger ms-1'} style={{ textTransform: 'capitalize' }}>{que_detail && que_detail.status}</span>
                                        </div> */}

                                        <div className='mb-2'>
                                            {/* <span style={{ color: '#9d9d9d', fontWeight: '500' }}>Created On:</span> */}
                                            <h5 className=''>{que_detail && que_detail.createdAt}</h5>
                                        </div>

                                        {/* <div className='mb-2'>
                                            <span style={{ color: '#9d9d9d', fontWeight: '500' }}>Corect Option:</span>
                                            <span className='ms-1'>{que_detail && que_detail.correct_ans}</span>
                                        </div> */}

                                    </div>

                                    <div className="row row-flex">

                                        <div className='col-md-12'>
                                            <div className='d-flex align-items-center'>
                                                <h6>
                                                    <span style={{ color: '#9d9d9d' }}>Question:</span>
                                                </h6>
                                                <h6 className='ms-2'>{que_detail && que_detail.question}</h6>
                                            </div>
                                        </div>

                                        {(que_detail && que_detail.option1) || (que_detail && que_detail.image_option1) ?
                                            <div className="col-12 col-md-6 col-lg-3">
                                                <div className="details_option match_height">
                                                    <div className='d-flex justify-content-between'>
                                                        <span style={{ color: '#2262C6', fontWeight: '600' }}>Option A</span>
                                                        <span>{que_detail.correct_ans == 'A' ? <FaCircleCheck size={20} className='text-success mb-2' /> : ''}</span>
                                                    </div>
                                                    <p>{que_detail && que_detail.option1}</p>
                                                    {que_detail && que_detail.image_option1 ?
                                                        <img src={process.env.REACT_APP_IMAGE_URL + `${que_detail.image_option1}`} alt="img" className='img-fluid' />
                                                        : ''
                                                    }
                                                </div>
                                            </div>
                                            : ''
                                        }

                                        {(que_detail && que_detail.option2) || (que_detail && que_detail.image_option2) ?
                                            <div className="col-12 col-md-6 col-lg-3 mt-3 mt-md-0 mt-lg-0">
                                                <div className="details_option match_height">
                                                    <div className='d-flex justify-content-between'>
                                                        <span style={{ color: '#2262C6', fontWeight: '600' }}>Option B</span>
                                                        <span>{que_detail.correct_ans == 'B' ? <FaCircleCheck size={20} className='text-success mb-2' /> : ''}</span>
                                                    </div>
                                                    <p>{que_detail && que_detail.option2}</p>
                                                    {que_detail && que_detail.image_option2 ?
                                                        <img src={process.env.REACT_APP_IMAGE_URL + `${que_detail.image_option2}`} alt="img" className='img-fluid' />
                                                        : ''
                                                    }
                                                </div>
                                            </div>
                                            : ''
                                        }

                                        {(que_detail && que_detail.option3) || (que_detail && que_detail.image_option3) ?
                                            <div className="col-12 col-md-6 col-lg-3 mt-3 mt-md-0 mt-lg-0">
                                                <div className="details_option match_height">
                                                    <div className='d-flex justify-content-between'>
                                                        <span style={{ color: '#2262C6', fontWeight: '600' }}>Option C</span>
                                                        <span>{que_detail.correct_ans == 'C' ? <FaCircleCheck size={20} className='text-success mb-2' /> : ''}</span>
                                                    </div>
                                                    <p>{que_detail && que_detail.option3}</p>
                                                    {que_detail && que_detail.image_option3 ?
                                                        <img src={process.env.REACT_APP_IMAGE_URL + `${que_detail.image_option3}`} alt="img" className='img-fluid' />
                                                        : ''
                                                    }
                                                </div>
                                            </div>
                                            : ''
                                        }

                                        {(que_detail && que_detail.option4) || (que_detail && que_detail.image_option4) ?
                                            <div className="col-12 col-md-6 col-lg-3 mt-3 mt-md-0 mt-lg-0">
                                                <div className="details_option match_height">
                                                    <div className='d-flex justify-content-between'>
                                                        <span style={{ color: '#2262C6', fontWeight: '600' }}>Option D</span>
                                                        <span>{que_detail.correct_ans == 'D' ? <PiSealCheckBold size={20} className='text-success mb-2' /> : ''}</span>
                                                    </div>
                                                    <p>{que_detail && que_detail.option4}</p>
                                                    {que_detail && que_detail.image_option4 ?
                                                        <img src={process.env.REACT_APP_IMAGE_URL + `${que_detail.image_option4}`} alt="img" className='img-fluid' />
                                                        : ''
                                                    }
                                                </div>
                                            </div>
                                            : ''
                                        }

                                        {(que_detail && que_detail.option5) || (que_detail && que_detail.image_option5) ?
                                            <div className="col-12 col-md-6 col-lg-3 mt-3 mt-md-0 mt-lg-0">
                                                <div className="details_option match_height">
                                                    <div className='d-flex justify-content-between'>
                                                        <span style={{ color: '#2262C6', fontWeight: '600' }}>Option E</span>
                                                        <span>{que_detail.correct_ans == 'E' ? <FaCircleCheck size={20} className='text-success mb-2' /> : ''}</span>
                                                    </div>
                                                    <p>{que_detail && que_detail.option5}</p>
                                                    {que_detail && que_detail.image_option5 ?
                                                        <img src={process.env.REACT_APP_IMAGE_URL + `${que_detail.image_option5}`} alt="img" className='img-fluid' />
                                                        : ''
                                                    }
                                                </div>
                                            </div>
                                            : ''
                                        }

                                    </div>

                                </div>

                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}